import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => ({
  '@global': {
    '.BOLD': {
      fontWeight: '500',
    },
  },
}))(() => null);
